import {
  getInvoiceDetails,
  getOrderFulfilmentInvoice
} from '../../../actions/order-service-action';
import store from '../../../store';

export const setConsignmentFormPayload = (
  consignmentFormFields,
  pickupLocationDetails,
  billingAddress,
  orderDescription
) => {
  const formData = {};
  consignmentFormFields?.forEach((section) => {
    section.fields?.forEach((field) => {
      if (field.type === 'COMBINE' && field.attributes) {
        field.attributes?.forEach((attr) => {
          formData[attr.name] = attr.value;
        });
      } else {
        formData[field.name] = field.value;
      }
    });
  });

  let locationObj = null;
  if (formData.pickupLocation && typeof formData.pickupLocation === 'object') {
    locationObj = pickupLocationDetails?.find(
      (loc) => loc.name === formData.pickupLocation.value
    );
  }

  locationObj && (formData.pickupLocation = locationObj);

  const payload = {
    successResponse: true,
    shipmentDimension: {
      noOfBoxes: formData['noOfBoxes'],
      height: formData['height'],
      width: formData['width'],
      length: formData['length'],
      weight: formData['weight']
    },

    pickupLocation: {
      name: formData?.pickupLocation['name'],
      addressLine1: formData?.pickupLocation['addressLine1'],
      addressLine2: formData?.pickupLocation['addressLine2'],
      city: formData?.pickupLocation['city'],
      district: formData?.pickupLocation['district'],
      state: formData?.pickupLocation['state'],
      country: formData?.pickupLocation['country'],
      pincode: formData?.pickupLocation['postalCode'],
      contactNo: formData?.pickupLocation['contactNo']
    },

    shippingAddress: {
      ...billingAddress?.shippingAddress,
      customerName:
        billingAddress?.userFirstName + ' ' + billingAddress?.userLastName,
      email: billingAddress?.userEmailId,
      companyName: billingAddress?.companyName
    },

    invoiceDetail: {
      invoiceDate: formData['invoiceDate'],
      invoiceNo: formData['invoiceNo']
    },

    userDetails: {
      typeOfUser: 'b2b',
      userInfo: [
        {
          b2bIdentifier: orderDescription?.buyerDetails?.companyId,
          userId: orderDescription?.buyerDetails?.userId,
          emailId: orderDescription?.buyerDetails?.userEmailId,
          role: 'buyer'
        },
        {
          b2bIdentifier: orderDescription?.sellerDetails?.companyId,
          userId: orderDescription?.sellerDetails?.userId,
          emailId: orderDescription?.sellerDetails?.userEmailId,
          role: 'seller'
        }
      ]
    },
    mappingInfo: {
      itemId: orderDescription?.productOrderDto?.productId
    },
    classifiers: {
      categoryId: orderDescription?.productDetailsDto?.category?.id
    },

    orderId: orderDescription?.productOrderDto?.productOrderId,
    region: process.env.REACT_APP_REGION,
    productOrderDetailId: orderDescription?.productOrderDto?.productOrderDetailId
  };
  return payload;
};

export const updateConsignmentFormFields = (prevSections, data) => {
  const { name, value, error } = data;
  return prevSections?.map((section) => ({
    ...section,
    fields: section.fields?.map((field) => {
      if (field.name === name) {
        return { ...field, value, error };
      }
      if (field.type === 'COMBINE' && field.attributes) {
        return {
          ...field,
          attributes: field.attributes.map((attr) =>
            attr.name === name ? { ...attr, value, error } : attr
          )
        };
      }
      return field;
    })
  }));
};

export const blurConsignmentFormFields = (prevFields, data) => {
  const { name, error } = data;
  return prevFields.map((field) => {
    if (field.name === name) {
      return { ...field, error };
    }
    if (field.type === 'COMBINE' && field.attributes) {
      return {
        ...field,
        attributes: field.attributes.map((attr) =>
          attr.name === name ? { ...attr, error } : attr
        )
      };
    }
    return field;
  });
};

export const mapPickupLocationOptions = (options) =>
  options?.map((item, idx) => ({
    id: String(idx + 1),
    label: `${item?.name}, ${item?.addressLine1}, ${item?.addressLine2}, ${item?.city}, ${item?.district}, ${item?.state}, ${item?.country}, ${item?.postalCode}, ${item?.contactNo}`,
    value: item?.name,
    displayValue: item?.name
  }));

export const getMappedConsignmentFormData = (
  consignmentDynamicFormFields,
  pickupLocationDetails
) =>
  consignmentDynamicFormFields?.map((section) => {
    if (section.id === 'pickup-location-section') {
      return {
        ...section,
        fields: section.fields?.map((field) =>
          field.name === 'pickupLocation'
            ? { ...field, options: mapPickupLocationOptions(pickupLocationDetails) }
            : field
        )
      };
    }
    return section;
  });

export const getConsignmentButtons = (handleClose, handleConsignmentFormSubmit) => [
  {
    label: 'Cancel',
    mode: 'secondary',
    onClick: handleClose
  },
  {
    label: 'Submit',
    mode: 'primary',
    onClick: handleConsignmentFormSubmit
  }
];

export const isConsignmentFormValid = (sections) => {
  const isInvalid = (field) => {
    if (field.type === 'COMBINE' && field.attributes) {
      return field.attributes?.some(
        (attr) =>
          (attr.validation?.rule?.required?.isRequired && !attr.value) || attr.error
      );
    }
    return (
      (field.validation?.rule?.required?.isRequired && !field.value) || field.error
    );
  };

  return !sections?.some((section) => section.fields?.some(isInvalid));
};

export const updateConsignmentFormFieldsWithInvoice = (
  mappedConsignmentFormDetails,
  invoiceResponse
) => {
  return mappedConsignmentFormDetails?.map((section) => {
    if (
      section.id === 'invoice-section' &&
      section.fields &&
      Array.isArray(section.fields)
    ) {
      const newFields = section.fields?.map((field) => {
        if (field.id === 'invoice-no' && invoiceResponse?.invoiceNumber) {
          return { ...field, value: invoiceResponse.invoiceNumber, disabled: true };
        }
        if (field.id === 'invoice-date' && invoiceResponse?.invoiceDate) {
          return { ...field, value: invoiceResponse.invoiceDate, disabled: true };
        }
        return field;
      });
      return { ...section, fields: newFields };
    }
    return section;
  });
};

export const handleDownloadInvoice = (dispatch, productOrderId, tenantId) => {
  dispatch(getInvoiceDetails(productOrderId, tenantId)).then((response) => {
    if (response?.invoiceNumber) {
      dispatch(getOrderFulfilmentInvoice(response?.invoiceNumber, tenantId));
    } else {
      dispatch({
        type: 'GET_INVOICE_INFO',
        payload:
          store.getState().ContentReducer?.content?.components?.order_history
            ?.invoice?.download_invoice_info
      });
    }
  });
};


export const getInvoiceInfoIcons = (handleClose) => [ 
  {
    label: 'OK',
    mode: 'primary',
    onClick: handleClose
  }
];
